/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestGetPlanInfoListRequest
 */
export interface RequestGetPlanInfoListRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestGetPlanInfoListRequest
     */
    baseId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetPlanInfoListRequest
     */
    createdUserId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RequestGetPlanInfoListRequest
     */
    isCompleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RequestGetPlanInfoListRequest
     */
    planName?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestGetPlanInfoListRequest
     */
    shipNum?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestGetPlanInfoListRequest
     */
    statusId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetPlanInfoListRequest
     */
    tenantId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetPlanInfoListRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestGetPlanInfoListRequest interface.
 */
export function instanceOfRequestGetPlanInfoListRequest(value: object): value is RequestGetPlanInfoListRequest {
    if (!('baseId' in value) || value['baseId'] === undefined) return false;
    if (!('statusId' in value) || value['statusId'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestGetPlanInfoListRequestFromJSON(json: any): RequestGetPlanInfoListRequest {
    return RequestGetPlanInfoListRequestFromJSONTyped(json, false);
}

export function RequestGetPlanInfoListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestGetPlanInfoListRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'],
        'createdUserId': json['created_user_id'] == null ? undefined : json['created_user_id'],
        'isCompleted': json['is_completed'] == null ? undefined : json['is_completed'],
        'planName': json['plan_name'] == null ? undefined : json['plan_name'],
        'shipNum': json['ship_num'] == null ? undefined : json['ship_num'],
        'statusId': json['status_id'],
        'tenantId': json['tenant_id'],
        'userId': json['user_id'],
    };
}

export function RequestGetPlanInfoListRequestToJSON(json: any): RequestGetPlanInfoListRequest {
    return RequestGetPlanInfoListRequestToJSONTyped(json, false);
}

export function RequestGetPlanInfoListRequestToJSONTyped(value?: RequestGetPlanInfoListRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'created_user_id': value['createdUserId'],
        'is_completed': value['isCompleted'],
        'plan_name': value['planName'],
        'ship_num': value['shipNum'],
        'status_id': value['statusId'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

